import {
  req,
  len,
  withParams
} from 'vuelidate/lib/validators/common';

export default (min, max) => withParams(
    {type: 'lengthRange', min, max},
    (value) => {
      return !req(value) || len(value) <= max && len(value) >= min;
    }
);